import IDMGlobals from '../IDMGlobals';
//
const MemCache = require("node-cache");
/**
 *
 */
export default class _CookiesRemote {

  /**
   * constructor - description
   *
   * @return {type}  description
   */
  constructor() {
    this.cookieEngine = new MemCache();
  }

  /**
   * cleanKey - description
   *
   * @param  string | string[] key description
   * @return {type}     description
   */
  async cleanKey(key) { 
    return new Promise(async (resolve) => {
      resolve(this.cookieEngine.del(key));
    });
  }

  /**
   * getValue - description
   *
   * @param  {type} key description
   * @return {type}     description
   */
  async getValue(key) { 
    return new Promise(async (resolve) => {
      resolve(this.cookieEngine.get(key));
    });
  }

  /**
   * setDefaultValue - description
   *
   * @param  {type} key description
   * @param  {type} val description
   * @return {type}     description
   */
  async setDefaultValue(key, val) {
    return await this.setValue(key, val, IDMGlobals.CookiesDefaultExpirationPeriod)
  }

  /**
   * setLongLiveValue - description
   *
   * @param  {type} key description
   * @param  {type} val description
   * @return {type}     description
   */
  async setLongLiveValue(key, val) {
    return await this.setValue(key, val, IDMGlobals.CookiesLongLiveExpirationPeriod)
  }

  /**
   * setValue - description
   *
   * @param  {type} key  description
   * @param  {type} val  description
   * @param  {type} ttl description
   * @return {type}      description
   */
  async setValue(key, val, ttl) {
    return new Promise(async (resolve) => {
      this.cookieEngine.set(key, val, ttl ? ttl / 1000 : 0); //in seconds here
      resolve();
    });
  }
}
